export const en = {
    translation: {
        app: {
            error: {
                title: "Oops! Something's wrong here...",
                event: 'Event: {{event}}',
                goBack: 'Go Back',
            },
        },
        components: {
            amountModifierInput: {
                plus: 'Plus',
                minus: 'Minus',
                set: 'As amount',
                percentage: 'Percent',
            },
            control: {
                dateInput: {
                    invalidDateFormat: 'Invalid date format',
                    dateBeforeMinDate: 'Date is before the allowed minimum date',
                    dateAfterMaxDate: 'Date is after the allowed maximum date',
                },
                phoneInput: {
                    invalidPhoneNumber: 'Invalid phone number for the given country',
                },
                searchInput: {
                    placeholder: 'Search',
                },
                combobox: {
                    createOption: 'Add {{query}}',
                    noOptions: 'No options found',
                    moreOptions: 'More options available please use search',
                    minQueryLength: 'Type at least {{length}} characters',
                    loading: 'Loading ...',
                },
                textAreaTags: {
                    sample: 'Sample',
                    placeholder: 'Placeholder',
                },
            },
            emptyState: {
                noAccess: {
                    title: 'No access',
                    subtitle: 'You have no access to this action',
                },
            },
            fileUpload: {
                tooBig: {
                    title: 'Some file(s) are too big',
                    message: 'One or more files are are exceeding the allowed maximum file sizeof {{maxSize}}',
                },
                uploadTitle: 'Uploading',
                dropFilesTitle: 'Dropt the file(s) now',
                dropHereTitle: 'Drop your files or',
                selectFiles: 'click here to choose',
                format: 'Format',
                size: 'Size',
            },
            dialog: {
                confirm: {
                    prefix: 'Please confirm by entering',
                    suffix: ':',
                },
            },
            pagination: {
                previousPage: 'Previous page',
                nextPage: 'Next page',
                show: 'Showing {{fromCount, int}} to {{toCount, int}}',
                total: 'of {{count, int}} total',
            },
            storageResourceSelect: {
                image: 'image',
                file: 'file',
                select: 'Select {{type}}',
                change: 'Change {{type}}',
                clear: 'Remove {{type}}',
            },
            useSelectFile: {
                tooBig: {
                    title: 'Some file(s) are too big',
                    message: 'One or more files are are exceeding the allowed maximum file sizeof {{maxSize}}',
                },
            },
        },
        routes: {
            errorPage: {
                goBack: 'Go back',
            },
        },
    },
}
